export enum OrderReturnRejectionReason {
  PRODUCT_USED = 'PRODUCT_USED',
  NO_OR_DAMAGED_PACKAGING = 'NO_OR_DAMAGED_PACKAGING',
  RETURN_PERIOD_EXPIRED = 'RETURN_PERIOD_EXPIRED',
  NO_IDENTIFICATION_OR_WARRANTY_CERTIFICATE = 'NO_IDENTIFICATION_OR_WARRANTY_CERTIFICATE',
  INCOMPLETE_PRODUCT = 'INCOMPLETE_PRODUCT',
  WRONG_PRODUCT_RETURNED = 'WRONG_PRODUCT_RETURNED',
  ERROR_IMAGE = 'ERROR_IMAGE',
}
